import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB3pI5Pz4HfWRlFr_yZww16sZVAiOljxTY",
  authDomain: "doc-hi-g.firebaseapp.com",
  projectId: "doc-hi-g",
  storageBucket: "doc-hi-g.firebasestorage.app",
  messagingSenderId: "1044185190855",
  appId: "1:1044185190855:web:ffc53e852bf547a50289e2",
  measurementId: "G-52LVT4TNP6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
